import { Pixelation, EffectComposer } from "@react-three/postprocessing";

export type PixelationLoaderProps = {
  isLoading: boolean;
};

export const PixelationLoader: React.FC<PixelationLoaderProps> = ({
  isLoading,
}) => {
  return isLoading ? (
    <EffectComposer>
      <Pixelation granularity={10} />
    </EffectComposer>
  ) : null;
};

export * from "./components/CubeLoader";
